module.exports = __webpack_public_path__ + "static/media/canary.f03be08e.jpeg";